import {routes, request} from "./"

export function checkName(commit, data) {
    return request(commit, routes.images.checkName, data, 'post')
}

export function uploadImage(commit, data) {
    return request(commit, routes.images.upload, data, 'post')
}

export function updateImage(commit, data) {
    return request(commit, routes.images.update, data, 'post')
}

export function updateImageables(commit, data) {
    return request(commit, routes.images.updateImageables, data, 'post')
}

export function deleteImage(commit, data) {
    return request(commit, routes.images.delete, data, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/images.js
// module id = 605
// module chunks = 0